var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedimento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32 1.44C4.32 0.646355 4.96635 0 5.76 0H8.64C9.43364 0 10.08 0.646355 10.08 1.44V2.88H12.96C13.7536 2.88 14.4 3.52636 14.4 4.32V12.24C14.4 13.0336 13.7536 13.68 12.96 13.68H1.44C0.646355 13.68 0 13.0336 0 12.24V4.32C0 3.52636 0.646355 2.88 1.44 2.88H4.32V1.44ZM5.76 2.88H8.64V1.44H5.76V2.88ZM1.44 4.32V12.24H12.96V4.32H1.44ZM7.2 5.76C7.59765 5.76 7.92 6.08236 7.92 6.48V7.92H9.36C9.75764 7.92 10.08 8.24235 10.08 8.64C10.08 9.03765 9.75764 9.36 9.36 9.36H7.92V10.8C7.92 11.1976 7.59765 11.52 7.2 11.52C6.80235 11.52 6.48 11.1976 6.48 10.8V9.36H5.04C4.64235 9.36 4.32 9.03765 4.32 8.64C4.32 8.24235 4.64235 7.92 5.04 7.92H6.48V6.48C6.48 6.08236 6.80235 5.76 7.2 5.76Z",
    fill: "#5AB2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedimento);
export default __webpack_public_path__ + "static/media/Procedimento.155928c8b532a3b41d1c64e170178653.svg";
export { ForwardRef as ReactComponent };